export default "__VITE_ASSET__OePTadGq__"